const StaElevData2 = {
    x: [
        4947.84, 4954.04, 4959.97, 4962.54, 4978.5, 4993.89, 4995.66, 4999.58,
        5009.31, 5013, 5024.55, 5036.83, 5047.24, 5054.23, 5062.53, 5077.74,
        5080.74, 5092.97, 5096.97, 5097.92, 5100.86, 5133.55, 5148.21, 5150.92,
        5169.89, 5180.27, 5195.84, 5202.69, 5237.85, 5250.13, 5267.84, 5283.82,
        5290.8, 5297.31, 5303.53, 5307.84, 5317.75, 5330.72, 5337.71, 5343.7,
        5350.68, 5356.57, 5361.99, 5385.89, 5387.44, 5390.7, 5405.63, 5408.54,
        5424.88, 5427.71, 5431.53, 5448.65, 5452.77, 5459.57, 5472.91, 5481.95,
        5486.85, 5494.4, 5506.27, 5512.57, 5519.18, 5527.82, 5540.46, 5552.6,
        5558.13, 5567.54, 5571.94, 5592.63, 5600.97, 5605.18, 5613.09, 5623.38,
        5625.89, 5634.64,
    ],
    y: [
        159.07, 158.92, 158.78, 158.69, 158.25, 157.78, 157.71, 157.52, 157.06,
        156.93, 156.66, 156.36, 156.09, 155.88, 155.76, 155.59, 155.51, 155.4,
        155.37, 155.35, 155.31, 154.64, 154.21, 154.18, 153.97, 153.49, 152.865,
        152.59, 152.35, 152.32, 152.2449, 152.22, 152.2, 152.18, 152.21, 152.235,
        152.23, 152.16, 152.16, 152.3, 152.31, 152.4, 152.46, 152.63, 152.64,
        152.67, 152.81, 152.81, 152.78, 152.8, 152.8, 152.84, 152.88, 152.98,
        153.06, 153.15, 153.19, 153.22, 153.37, 155.1, 155.85, 156.89, 158.2,
        158.78, 158.54, 159.09, 159.23, 157.92, 158.46, 157.9, 157.95, 157.96,
        158.04, 158.3,
    ],
}

const StaElevData = {
    x: [
        4947.84, 4954.04, 4959.97, 4962.54, 4978.5, 4993.89, 4995.66, 4999.58,
        5009.31, 5013, 5024.55, 5036.83, 5047.24, 5054.23, 5062.53, 5077.74,
        5080.74, 5092.97, 5096.97, 5097.92, 5100.86, 5133.55, 5148.21, 5150.92,
        5169.89, 5180.27, 5195.84, 5202.69, 5237.85, 5250.13, 5267.84, 5283.82,
        5290.8, 5297.31, 5303.53, 5307.84, 5317.75, 5330.72, 5337.71, 5343.7,
        5350.68, 5356.57, 5361.99, 5385.89, 5387.44, 5390.7, 5405.63, 5408.54,
        5424.88, 5427.71, 5431.53, 5448.65, 5452.77, 5459.57, 5472.91, 5481.95,
        5486.85, 5494.4, 5506.27, 5512.57, 5519.18, 5527.82, 5540.46, 5552.6,
        5558.13, 5567.54, 5571.94, 5592.63, 5600.97, 5605.18, 5613.09, 5623.38,
        5625.89, 5634.64,
    ],
    y: [
        159.07, 158.92, 158.78, 158.69, 158.25, 157.78, 157.71, 157.52, 157.06,
        156.93, 156.66, 156.36, 156.09, 155.88, 155.76, 155.59, 155.51, 155.4,
        155.37, 155.35, 150.31, 149.64, 149.21, 149.18, 148.97, 148.49, 147.865,
        152.59, 152.35, 152.32, 152.2449, 152.22, 152.2, 152.18, 152.21, 152.235,
        152.23, 152.16, 152.16, 152.3, 152.31, 152.4, 152.46, 152.63, 152.64,
        152.67, 152.81, 152.81, 152.78, 152.8, 152.8, 152.84, 152.88, 152.98,
        153.06, 153.15, 153.19, 153.22, 153.37, 155.1, 155.85, 156.89, 158.2,
        158.78, 158.54, 159.09, 159.23, 157.92, 158.46, 157.9, 157.95, 157.96,
        158.04, 158.3,
    ],
}

const BankStationData = {
    x: [5572.01, 5600.89],
    y: [159.24, 158.45]
}

const WSEL = {
    x: [5048, 5520],
    y: [155, 155]
}

const PlotData = {
    StaElevData,
    StaElevData2,
    BankStationData,
    WSEL
}

export default PlotData